<script setup>
// Copies a link to the clipboard, saying so for a moment. Without the Clipboard API (an insecure origin), the
// link is shown to be copied by hand instead.
import { onUnmounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  url: String,
  label: String,
})

const CONFIRMATION_DURATION = 2000

const { t } = useI18n()
const copied = ref(false)
const failed = ref(false)
let timer = null

function absoluteUrl() {
  return new URL(props.url, window.location.href).toString()
}

async function copy() {
  try {
    await navigator.clipboard.writeText(absoluteUrl())
    copied.value = true
    clearTimeout(timer)
    timer = setTimeout(() => { copied.value = false }, CONFIRMATION_DURATION)
  } catch {
    failed.value = true
  }
}

onUnmounted(() => clearTimeout(timer))
</script>

<template>
  <span class="d-inline-flex flex-wrap gap-2 align-items-center">
    <button type="button" class="btn btn-sm btn-outline-secondary" @click="copy">
      <span :class="['bi', 'me-1', copied ? 'bi-check-lg' : 'bi-link-45deg']"></span>
      {{ copied ? t('copy_link.copied') : (label || t('copy_link.copy')) }}
    </button>
    <input v-if="failed" type="text" class="form-control form-control-sm w-auto" readonly :value="absoluteUrl()" :aria-label="t('copy_link.manual')" @focus="$event.target.select()">
  </span>
</template>
